import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { SameNumberValidator } from "src/app/directives/same-number.directive";
import { Bulto } from "src/app/models/Dte/Exportacion/Bulto";
import { CodigosAduana } from "src/app/models/Dte/Exportacion/CodigosAduana";
import { Pais } from "src/app/models/Dte/Exportacion/Pais";
import { Puerto } from "src/app/models/Dte/Exportacion/Puerto";
import { UnidadMedida } from "src/app/models/Dte/Exportacion/UnidadMedida";
import { ViaTransporte } from "src/app/models/Dte/Exportacion/ViaTransporte";
import { ExportacionTransporteDte } from "src/app/models/Dte/exportacionDte";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
   selector: "app-exportacion-dte",
   templateUrl: "./exportacion-dte.component.html",
   styleUrls: ["./exportacion-dte.component.scss"],
})
export class ExportacionDteComponent implements OnInit {
   @ViewChild("localForm") private localFormRef: NgForm;
   public exportFormGroup: FormGroup = this.formBuilder.group({});
   //public bultoSource:any[] = ["a"];
   public paisesSource: Pais[] = [];
   public viaTransporteSource: ViaTransporte[] = [];
   public puertosNacionalesSource: Puerto[] = [];
   public puertosDesembarqueSource: Puerto[] = [];
   public selectionDesembarqueSource: Puerto[] = [];
   public selectionEmbarqueSource: Puerto[] = [];
   private exportacionDte: ExportacionTransporteDte = new ExportacionTransporteDte();
   private packagesList: Bulto[] = [];
   public isLocalService: boolean = false;
   private codigosAduana: CodigosAduana;
   public unidadesMedidaSource: UnidadMedida[];
   constructor(private formBuilder: FormBuilder, private facturador: FacturacionIndividualService, private localStorage: LocalStorageService, private ref: ChangeDetectorRef, private utilities: UtilitiesService) {}

   ngOnInit(): void {
      this.codigosAduana = this.localStorage.getCodigosAduana();
      this.puertosNacionalesSource = this.codigosAduana.puertos;
      this.filterNationalPorts(environment.country_code_port);
      this.paisesSource = this.codigosAduana.paises;
      this.puertosDesembarqueSource = this.codigosAduana.puertos;
      this.viaTransporteSource = this.codigosAduana.viaTransportes;
      this.utilities.sortAlphabeth(this.viaTransporteSource, "descripcion");
      this.unidadesMedidaSource = this.codigosAduana.unidadMedidas;
      this.utilities.sortAlphabeth(this.unidadesMedidaSource, "nombreUnidadMedida");
      this.filterPortBySelectedCountry();
      this.setExportForm();
   }

   setExportForm() {
      this.exportFormGroup = this.formBuilder.group(
         {
            tara: [0, [Validators.required, Validators.pattern("^[0-9]+$")]],
            medidaTara: [this.unidadesMedidaSource[this.getIndexForArrayItem("abreviatura", "KN", this.unidadesMedidaSource)], [Validators.required]],
            pesoNeto: [0, [Validators.required]],
            medidaPesoNeto: [this.unidadesMedidaSource[this.getIndexForArrayItem("abreviatura", "KN", this.unidadesMedidaSource)], [Validators.required]],
            pesoBruto: [0, [Validators.required]],
            //medidaPesoBruto:[,[Validators.required]],
            totalBultos: [0, [Validators.required]],
            flete: [0, [Validators.required]],
            seguro: [0, [Validators.required]],
            viaTransporte: [this.viaTransporteSource[4], [Validators.required]],
            paisReceptor: [this.paisesSource[0], [Validators.required]],
            puertoEmbarque: [this.selectionEmbarqueSource[0]],
            puertoDesembarque: [this.selectionDesembarqueSource[0]],
         },
         { validators: SameNumberValidator }
      );
      this.exportFormGroup.controls.pesoBruto.disable();
   }

   onSubmit() {
      //this.filterPortBySelectedCountry();
      this.exportacionDte.tara = this.exportFormGroup.controls.tara.value;
      this.exportacionDte.pesoNeto = this.exportFormGroup.controls.pesoNeto.value;
      this.exportacionDte.pesoBruto = +this.exportacionDte.tara + +this.exportacionDte.pesoNeto;
      this.exportFormGroup.controls.pesoBruto.patchValue(this.exportacionDte.pesoBruto);
      if (this.exportFormGroup.valid) {
         this.exportacionDte.tara = this.exportFormGroup.controls.tara.value;
         let unidadMedidaTara: UnidadMedida = this.exportFormGroup.controls.medidaTara.value;
         this.exportacionDte.medidaTara = unidadMedidaTara ? unidadMedidaTara.codigoSigla : undefined;
         this.exportacionDte.pesoNeto = this.exportFormGroup.controls.pesoNeto.value;
         let unidadMedida: UnidadMedida = this.exportFormGroup.controls.medidaPesoNeto.value;
         this.exportacionDte.medidaPesoNeto = unidadMedida ? unidadMedida.codigoSigla : undefined;
         //this.exportacionDte.medidaPesoBruto = this.exportFormGroup.controls.medidaPesoBruto.value;
         this.exportacionDte.medidaPesoBruto = unidadMedida ? unidadMedida.codigoSigla : undefined;
         this.exportacionDte.pesoBruto = +this.exportacionDte.tara + +this.exportacionDte.pesoNeto; //this.exportFormGroup.controls.pesoBruto.value;
         this.exportFormGroup.controls.pesoBruto.patchValue(this.exportacionDte.pesoBruto);
         this.exportacionDte.flete = this.exportFormGroup.controls.flete.value;
         this.exportacionDte.seguro = this.exportFormGroup.controls.seguro.value;
         let viaTransporte: ViaTransporte = this.exportFormGroup.controls.viaTransporte.value;
         this.exportacionDte.viaTransporte = viaTransporte ? viaTransporte.descripcion.toString() : undefined;
         this.exportacionDte.codigoViaTransporte = viaTransporte ? viaTransporte.codigoSii : undefined;
         let paisSelected: Pais = this.exportFormGroup.controls.paisReceptor.value;
         this.exportacionDte.paisReceptor = paisSelected ? paisSelected.nombre : undefined;
         this.exportacionDte.codigoPaisReceptor = paisSelected ? paisSelected.codigoSii : undefined;
         this.exportacionDte.codigoPaisDestino = paisSelected ? paisSelected.codigoSii : undefined;
         this.exportacionDte.paisEmisor = this.paisesSource.find((pais) => pais.paisId == environment.country_code_port).nombre;
         let puertoNacional: Puerto = this.exportFormGroup.controls.puertoEmbarque.value;
         this.exportacionDte.puertoEmbarque = puertoNacional ? puertoNacional.puertoId : undefined;
         this.exportacionDte.codigoPuertoEmbarque = puertoNacional ? puertoNacional.codigoSii : undefined;
         let puertoDestino: Puerto = this.exportFormGroup.controls.puertoDesembarque.value;
         this.exportacionDte.puertoDesembarque = puertoDestino ? puertoDestino.puertoId : undefined;
         this.exportacionDte.codigoPuertoDesembarque = puertoDestino ? puertoDestino.codigoSii : undefined;
         this.exportacionDte.territorioEmbarque = puertoNacional ? puertoNacional.territorio : undefined;
         this.exportacionDte.territorioDesembarque = puertoDestino ? puertoDestino.territorio : undefined;
         this.exportacionDte.haveTransport = !this.isLocalService;
         if (!this.isLocalService) {
            if (this.packagesList && this.packagesList.length > 0) {
               this.exportacionDte.listaBultos = this.packagesList;
               let sumListQuantities = this.packagesList.reduce((sum, current) => (sum += current.cantidadBultos), 0);
               this.exportFormGroup.controls.totalBultos.patchValue(sumListQuantities);
               this.exportacionDte.totalBultos = this.exportFormGroup.controls.totalBultos.value;
               //calculate total of packages, bultos
            } 
            else {
               Swal.fire({
                  icon: "error",
                  title: "Error en Bultos",
                  text: "Los datos de exportación requieren indicar por lo menos un detalle de bulto",
               });
               return;
            }
         }
         this.facturador.updateExportacionTransporte(this.exportacionDte);
      }
   }

   getPackagesList($event) {
      this.packagesList = $event;
      if (!this.isLocalService) {
         if (this.packagesList && this.packagesList.length > 0) {
            this.exportacionDte.listaBultos = this.packagesList;
            let sumListQuantities = this.packagesList.reduce((sum, current) => (sum += current.cantidadBultos), 0);
            this.exportFormGroup.controls.totalBultos.patchValue(sumListQuantities);
            this.exportacionDte.totalBultos = this.exportFormGroup.controls.totalBultos.value;
            this.onSubmit();
            //calculate total of packages, bultos
         } else {
            Swal.fire({
               icon: "error",
               title: "Error en Bultos",
               text: "Los datos de exportación requieren indicar por lo menos un detalle de bulto",
            });
            return;
         }
      }
   }

   changeLocalService($event) {
      this.isLocalService = $event.target.checked;
      if (!this.localFormRef.form.touched) {
         this.localFormRef.form.markAsTouched();
      }
      //remove all validations
      if (this.isLocalService) {
         this.exportFormGroup.clearValidators();
         this.ref.detectChanges();
         Object.keys(this.exportFormGroup.controls).forEach((key) => {
            this.exportFormGroup.get(key).setValidators([]);
         });
         Object.keys(this.exportFormGroup.controls).forEach((key) => {
            this.exportFormGroup.get(key).setErrors(null);
         });
         this.exportFormGroup.updateValueAndValidity();
         this.localFormRef.form.updateValueAndValidity();
         this.ref.detectChanges();
      } else if (!this.isLocalService) {
         this.ref.detectChanges();
         Object.keys(this.exportFormGroup.controls).forEach((key) => {
            this.exportFormGroup.get(key).setValidators([Validators.required]);
         });
         Object.keys(this.exportFormGroup.controls).forEach((key) => {
            this.exportFormGroup.get(key).updateValueAndValidity();
         });
         this.exportFormGroup.updateValueAndValidity();
         this.localFormRef.form.updateValueAndValidity();
         this.ref.detectChanges();
      }
      this.onSubmit();
   }

   filterPortBySelectedCountry() {
      if (this.exportFormGroup.controls.paisReceptor) {
         let selectedCountry: Pais = this.exportFormGroup.controls.paisReceptor.value;
         this.selectionDesembarqueSource = this.puertosDesembarqueSource.filter((puerto) => puerto.codigoPais == selectedCountry.paisId);
         this.utilities.sortAlphabeth(this.selectionDesembarqueSource, "nombrePuerto");
         this.exportFormGroup.controls.puertoDesembarque.patchValue(this.selectionDesembarqueSource[0]);
      }
   }

   filterNationalPorts(code: number) {
      this.selectionEmbarqueSource = this.puertosNacionalesSource.filter((puerto) => puerto.codigoPais == code);
      this.utilities.sortAlphabeth(this.selectionEmbarqueSource, "nombrePuerto");
   }

   getIndexForArrayItem(propertyName: string, propertyValue: string, searchArray: any[]): number {
      return searchArray.findIndex((item) => item[propertyName] == propertyValue);
   }
}
